module.exports = __webpack_public_path__ + "static/media/garbage.56b66ec8.svg";